import { FrequentlyQuestion } from "../../../models/frequently-question.model";

export const WHATSAPP_URL = "https://api.whatsapp.com/send?phone=555193914753";
// Convite para feedback no Início: mesmo número do suporte, com a mensagem já preenchida
export const WHATSAPP_FEEDBACK_MESSAGE = "Olá! Tenho um feedback sobre a ProAtivos:";
export const whatsappFeedbackUrl = () =>
  `${WHATSAPP_URL}&text=${encodeURIComponent(WHATSAPP_FEEDBACK_MESSAGE)}`;
export const SUPPORT_EMAIL = "suporte@plataformaproativos.com.br";
export const INSTAGRAM_URL = "https://www.instagram.com/plataformaproativos/";

export const FAQ: FrequentlyQuestion[] = [
  {
    question: "Paguei a ProAtivos por pix e ainda não liberou, o que fazer?",
    answers: ["R: Saia e entre novamente com seu login e senha. Se o erro permanecer, entre em contato com a gente."],
  },
  {
    question: "A plataforma ProAtivos tem um período de teste grátis?",
    answers: ["R: Sim, nossos planos tem garantia de 7 dias na primeira compra. Para solicitar o reembolso, entre em contato com nosso suporte via WhatsApp."],
  },
  {
    question: "Estou com dúvidas sobre os planos disponíveis.",
    answers: ["R: Na plataforma ProAtivos, você paga adiantado e recarrega quando quiser. Sem renovação automática. "],
  },
  {
    question: "Estou com problemas no pagamento, o que fazer?",
    answers: ["R: Tente mudar o cartão utilizado ou a forma de pagamento. Se o erro persistir, entre em contato com o nosso suporte e detalhe o ocorrido."],
  },
  {
    question: "Tenho sugestões para melhorar a plataforma, o que fazer?",
    answers: ["R: Entre em contato conosco pelo e-mail ou whatsapp. Vamos adorar receber seu feedback!"],
  },
  {
    question: "Canais para contato",
    answers: ["R: E-mail do suporte: suporte@plataformaproativos.com.br", "Whatsapp: (51) 99391-4753"],
  },
];

/** Remove diacríticos + lowercase — busca case/accent-insensitive. */
function normalize(str: string): string {
  return str
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
}

export function filterFaq(search: string): FrequentlyQuestion[] {
  if (!search.trim()) return FAQ;
  const q = normalize(search);
  return FAQ.filter((item) => normalize(item.question).includes(q) || item.answers.some((a) => normalize(a).includes(q)));
}
